import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

interface BrandDetailsResponse {
  id: number;
  title: string;
  field_common_malay_title: string;
  field_common_mandarin_title: string;
  field_common_image: string;
  field_created_at_brands: string;
  field_updated_at_brands: string;
  publish: boolean;
  published: boolean;
}

// edit api call
const fetchBrandDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/get-all-foodandbeverage-brands/${id}`);
  return response.data[0];
};

const useBrandDocumentDetails = (
  id: string,
  options?: UseQueryOptions<BrandDetailsResponse, DefaultError, BrandDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<BrandDetailsResponse, DefaultError> => {
  return useQuery<BrandDetailsResponse, DefaultError, BrandDetailsResponse, QueryKey>(
    {
      queryKey: ["brandDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchBrandDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useBrandDocumentDetails };
